// extracted by mini-css-extract-plugin
export var wrapper = "ContactListItem-module--wrapper--nVrqE";
export var nameOfContact = "ContactListItem-module--nameOfContact--HH783";